export function isSpeechToTextSupported(): boolean {
  if (typeof window === 'undefined') return false;
  const hasUserMedia = !!navigator?.mediaDevices?.getUserMedia;
  const hasWorklet = typeof AudioWorkletNode !== 'undefined';
  return hasUserMedia && hasWorklet;
}
